import React, { FunctionComponent } from "react";
import "./index.scss";

type SpinnerProps = {};

export const Spinner: FunctionComponent<SpinnerProps> = () => <div className="spinner" />;
